import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import bg1 from "../assets/img/bg1.jpg";
import apiClient from "../utils/config/apiClient";
import Spinner1 from "../components/common/spinners";
import BtnSpinner from "../components/common/btnSpinners";
import dedalogo from "../assets/dedaImg/dedalogo.png"
import dedaBg from "../assets/dedaImg/s4 (1).jpg"
import useProfileStore from "../store/patient/profileStore";
import useManagePatient from "../hooks/patientDashboard/useManagePatient";
import { toast } from "sonner";

export default function GetCredentials() {
  const { login } = useAuth();
  const {profile, saveprofile}= useProfileStore()
  const {findPatient, findPatientAlt} = useManagePatient()
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("password");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [modal, setModal] = useState(false)
  const [response, setResponse] = useState([])
  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState({})

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    localStorage.setItem("localEmail", userName)
    try {
      const response = await apiClient.post("/public/portal?url=auth/login/patient", {
        email: userName,
        password: password
      });

      if (response.data) {
       
        console.log(response?.data, 'respose data')
        if (response?.data?.otp == true) {
          navigate("/pages/verify")
          
        } else if(response?.data?.token) {
          toast.success(`Welcome ${response?.data?.other_names} ${response?.data?.surname}`)
          localStorage.setItem("user", JSON.stringify(response?.data,"user"))
          localStorage.setItem("token", response?.data?.token)
          login(response.data); // Store user data and token in context
          setLoading(false);
          saveprofile(response?.data)
          localStorage.setItem('userId', response?.data?.id)
          findPatientAlt(response?.data?.id)
          navigate("/dashboard/overview")
        }else if(response?.data?.users){
        //  toast.error("users")
        setModal(true)
        setLoading(false)
        setUsers(response?.data?.users)
        } 
        else{
          toast.error('Email/Password Wrong')
          setLoading(false)
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
      setLoading(false)
      // alert(error);
      toast.error(error|| "Login Failed")
      setLoading(false);
    }
  };


   const handleSubmitSelectedUSer = async (user) => {
    // e.preventDefault();
    setLoading(true);
    localStorage.setItem("localEmail", userName)
    try {
      const response = await apiClient.post("/public/portal?url=auth/login/patient", {
        email: userName,
        password: password,
        patientId:user?.id
      });

      if (response.data) {
       
        console.log(response?.data, 'respose data')
        if (response?.data?.otp == true) {
          navigate("/pages/verify")
          
        } else if(response?.data?.token) {
          toast.success(`Welcome ${response?.data?.other_names} ${response?.data?.surname}`)
          localStorage.setItem("user", JSON.stringify(response?.data,"user"))
          localStorage.setItem("token", response?.data?.token)
          login(response.data); // Store user data and token in context
          setLoading(false);
          saveprofile(response?.data)
          localStorage.setItem('userId', response?.data?.id)
          findPatientAlt(response?.data?.id)
          navigate("/dashboard/overview")
        }else if(response?.data?.users){
        //  toast.error("users")
        setModal(true)
        setLoading(false)
        setUsers(response?.data?.users)
        } 
        else{
          toast.error('Email/Password Wrong')
          setLoading(false)
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
      setLoading(false)
      // alert(error);
      toast.error(error|| "Login Failed")
      setLoading(false);
    }
  };

  // console.log(profile, 'profilexx')

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
            <Card.Header>
              {/* <Link to="/" className="header-logo mb-5">Deda</Link> */}
              {/* <Link to="/" className="header-logo mb-5">Welcome !</Link>  */}
              <Link to="/" className="header-logo mb-5"><img src={dedalogo} alt=""/></Link> 
              <Card.Title>Sign In</Card.Title>
              <Card.Text>Welcome back! Please sign in to continue.</Card.Text>
            </Card.Header>
            <Card.Body>
             {
              !modal&&(
                 <Form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your email address"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
                
                <Button type="submit" className=" btn-deda">{loading ? <BtnSpinner/> :"Sign In"}</Button>
              </Form>
              )
             }

             {
              modal &&(
                <div>
                 <h6>Please select to confirm you account</h6>
                 {
                  users?.map((user)=>(
                     <Button onClick={()=>handleSubmitSelectedUSer(user)} className=" mb-2 btn-deda">{loading ? <BtnSpinner/> :""}
                  {user?.name} {user?.email}
                  </Button>
                  ))
                 }

                </div>
              )
             }
            </Card.Body>
            <Card.Footer className="" style={{textAlign:"left"}}>
              Already have an account? <Link to="/pages/signin2" className=" text-deda">Sign In</Link>
            </Card.Footer>
          </Card>
        </Col>
        <Col className="d-none d-lg-block auth-container">
          <img src={dedaBg} className="auth-img" alt="" />
        </Col>
      </Row>
    </div>
  );
}
